export default __webpack_public_path__ + "static/media/pieGraph.a087bcd6.svg";